import React from "react";
import { useTranslation } from "react-i18next";

import ProductPicker from "../../../components/catalog/pickers/ProductPicker";
import EvaluationPeriodPicker from "../../../components/filters/EvaluationPeriodPicker";

function formatDateOnly(value, language = "en") {
  if (!value) return "";
  const raw = String(value);
  const direct = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  const d = new Date(direct ? `${direct[1]}T00:00:00` : value);
  if (Number.isNaN(d.getTime())) return raw;
  const locale = String(language || "en").startsWith("pl") ? "pl-PL" : "en-GB";
  return d.toLocaleDateString(locale, { year: "numeric", month: "2-digit", day: "2-digit" });
}

function StockMovementFilters({
  period,
  selectedProduct,
  onProductSelect,
  searchProducts,
  locations = [],
  locationId = "",
  onLocationChange,
  movementType = "",
  movementTypes = [],
  onMovementTypeChange,
  selectedBatch = null,
  onClearBatch,
  onClear,
  loading = false,
}) {
  const { t, i18n } = useTranslation(["common", "stock"]);

  return (
    <div className="stock-audit-filters" aria-label={t("stock:audit.filtersAriaLabel")}>
      {selectedBatch && (
        <div className="stock-audit-batch-context" role="status">
          <span>{t("stock:audit.batchFilter")}</span>
          <strong>{selectedBatch.batch_number || `#${selectedBatch.id}`}</strong>
          {selectedBatch.expiry_date ? (
            <small>{t("stock:audit.batchExpiry", { date: formatDateOnly(selectedBatch.expiry_date, i18n.resolvedLanguage || i18n.language) })}</small>
          ) : null}
          <button
            type="button"
            className="stock-audit-batch-context__clear"
            onClick={onClearBatch}
            disabled={loading}
            aria-label={t("stock:audit.clearBatchFilter")}
            title={t("stock:audit.clearBatchFilter")}
          >
            ×
          </button>
        </div>
      )}

      <div className="stock-audit-filters__period">
        <EvaluationPeriodPicker
          controller={period}
          disabled={loading}
          className="stock-audit-period"
          modeLabel={t("stock:audit.periodMode")}
          displayLabel={t("stock:audit.period")}
          fromLabel={t("stock:audit.periodFrom")}
          toLabel={t("stock:audit.periodTo")}
        />
      </div>

      <div className="stock-audit-filters__product">
        <ProductPicker
          key={selectedProduct?.id ? `movement-product-${selectedProduct.id}` : "movement-product-all"}
          label={t("stock:audit.productFilter")}
          selectedProduct={selectedProduct}
          onSelect={onProductSelect}
          searchProducts={searchProducts}
          searchParams={{}}
          context="stock"
          helperText=""
          disabled={loading}
        />
      </div>

      <label className="stock-audit-filters__field">
        {t("stock:overview.location")}
        <select
          value={locationId}
          onChange={(event) => onLocationChange?.(event.target.value)}
          disabled={loading}
        >
          <option value="">{t("stock:overview.allLocations")}</option>
          {locations.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
        </select>
      </label>

      <label className="stock-audit-filters__field">
        {t("stock:audit.movementTypeFilter")}
        <select
          value={movementType}
          onChange={(event) => onMovementTypeChange?.(event.target.value)}
          disabled={loading}
        >
          <option value="">{t("stock:audit.allMovementTypes")}</option>
          {movementTypes.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </label>

      <div className="stock-audit-filters__actions">
        <button
          type="button"
          className="stock-btn stock-btn--outline"
          onClick={onClear}
          disabled={loading}
        >
          {t("stock:audit.clearFilters")}
        </button>
      </div>
    </div>
  );
}

export default StockMovementFilters;
